<section class="flex flex-row justify-between gap-2">
    <section class="flex-1">
        <h1 class="!text-sm">{{ 'status' | transloco }}</h1>
        <ul class="p-0 grid grid-cols-2 gap-2">
            @for (status of statusList; track status) {
                <li
                    class="p-1 flex items-center cursor-pointer"
                    (click)="setStatusValue(status, formGroup()!.controls.status!.value.includes(status))">
                    <app-checkbox
                        class="pt-0.5"
                        [checkboxState]="
                            formGroup().controls.status!.value.includes(status)
                                ? CheckboxState.CHECKED
                                : CheckboxState.UNCHECKED
                        " />

                    <app-field-intervention-status
                        class="mx-2"
                        [hasTooltip]="false"
                        [size]="1.5"
                        [status]="status" />
                </li>
            }
        </ul>
    </section>
    <section class="flex-1">
        <h1 class="!text-sm">{{ 'format' | transloco }}</h1>
        <ul class="p-0 grid grid-cols-2 gap-2">
            @for (format of formatList; track format) {
                <li
                    class="p-1 flex items-center gap-2 cursor-pointer"
                    (click)="setFormatValue(format, formGroup()!.controls.formats!.value.includes(format))">
                    <app-checkbox
                        class="pt-0.5"
                        [checkboxState]="
                            formGroup()!.controls.formats!.value.includes(format)
                                ? CheckboxState.CHECKED
                                : CheckboxState.UNCHECKED
                        " />

                    <span>{{ format === Format.ADVANCED_XLSX ? ('report' | transloco) : format }}</span>
                </li>
            }
        </ul>
    </section>
</section>
